import React, { memo } from "react";
import SubSectionWrapper from "./SubSectionWrapper";
import Container from "../../../../../../../shared-components/css-modules/lexus/atoms/Container";
import Text from "../../../../../../../shared-components/css-modules/lexus/atoms/Text";
import styles from "./Hero.module.scss";
import { CarConfigConfigureSectionsLbx } from "../../../../../../utils/types/SectionTypesLbx";
import type { SectionWrapperPropagationProps } from "../../../../common/section-wrapper/SectionWrapper";
import SpinContainer from "../../../../common/spin/SpinContainer";
import { CarConfigLabel } from "../../../../../../utils/labelUtils";
import SliderWrapper from "../../../../common/spin/sliderWrapper/SliderWrapper";

const Hero: React.FC<SectionWrapperPropagationProps> = ({ sectionRefs }): JSX.Element => {
    return (
        <SubSectionWrapper
            sectionId={CarConfigConfigureSectionsLbx.AtmosphereWelcome}
            sectionRef={sectionRefs.get(CarConfigConfigureSectionsLbx.AtmosphereWelcome)}
        >
            <Container className={styles.hero}>
                <Text tag="h1" variant="apheleia-h2" className={styles["hero-title"]} spacing="spacing-2">
                    <CarConfigLabel label="carConfigLbxWelcome" />
                </Text>
                <SpinContainer settings={{ center: true, autoHeight: true, hideSpinNavigation: true }} />
                <SliderWrapper />
            </Container>
        </SubSectionWrapper>
    );
};

export default memo(Hero);
